import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'getSafeHTMLEmail',
    standalone: true
})
export class GetSafeHTMLEmailPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) { }

    transform(template: string): SafeHtml {
        if(!template) return "";
        
        return this.sanitizer.bypassSecurityTrustHtml(template)
    }
}